// @ts-ignore
import React from "react";
import { gql, useMutation } from "@apollo/client";

interface AlertActionResponse {
  markAsSeen?: {
    errors?: Array<{ message: string; path: string }> | null;
    message?: string | null;
  };
  trackAlertClick?: {
    errors?: Array<{ message: string; path: string }> | null;
    message?: string | null;
  };
}

interface AlertActionVariables {
  id: string;
  provider?: string;
}

export const MARK_AS_SEEN_MUTATION = gql`
  mutation MarkAsSeenMutation($id: ID!, $provider: String) {
    markAsSeen(id: $id, provider: $provider) {
      errors {
        message
        path
      }
      message
    }
  }
`;

export const TRACK_ALERT_CLICK_MUTATION = gql`
  mutation TrackAlertClickMutation($id: ID!, $provider: String) {
    trackAlertClick(id: $id, provider: $provider) {
      errors {
        message
        path
      }
      message
    }
  }
`;

export const useMarkAsSeen = () => {
  const [markAsSeenMutation, { data, loading, error }] = useMutation<
    AlertActionResponse,
    AlertActionVariables
  >(MARK_AS_SEEN_MUTATION);

  const markAsSeen = async (variables: AlertActionVariables) => {
    const result = await markAsSeenMutation({ variables });
    return result;
  };

  return { markAsSeen, data, loading, error };
};

export const useTrackAlertClick = () => {
  const [trackAlertClickMutation, { data, loading, error }] = useMutation<
    AlertActionResponse,
    AlertActionVariables
  >(TRACK_ALERT_CLICK_MUTATION);

  const trackAlertClick = async (variables: AlertActionVariables) => {
    const result = await trackAlertClickMutation({ variables });
    return result;
  };

  return { trackAlertClick, data, loading, error };
};